import { combineReducers } from 'redux';

import application from 'containers/App/reducer';
import table from 'containers/Table/reducer';

import home from 'pages/Home/reducer';
import services from 'pages/Services/reducer';
import detalization from 'pages/Detalization/reducer';
import detalizationNew from 'pages/DetalizationNew/store/reducer';
import settings from 'pages/Settings/reducer';
import messages from 'pages/Messages/reducer';
import personalData from 'pages/PersonalData/reducer';
import { internetReducer as internet } from 'pages/Internet/store/reducer';
import tv from 'pages/TV/reducer';
import insurance from 'pages/Insurance/reducer';
import family from 'pages/Family/store/reducer';
import familyChild from 'pages/FamilyChild/store/reducer';

const reduceReducers = (...reducers) => (previous, current) => reducers.reduce((p, r) => r(p, current), previous);

export default reduceReducers(
  combineReducers({
    application,
    home,
    services,
    detalization,
    detalizationNew,
    settings,
    messages,
    personalData,
    internet,
    tv,
    insurance,
    family,
    familyChild,
  }),
  table,
);
